import { useState, useEffect } from 'react';
import { createClient } from '@supabase/supabase-js';
import ProductCard from '../../../components/ProductCard';

const supabase = createClient(
  import.meta.env.VITE_PUBLIC_SUPABASE_URL,
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY
);

interface Product {
  id: number;
  name: string;
  brand: string;
  current_price: number;
  original_price: number;
  discount_rate: number;
  image_url: string;
  rating: number;
  source: string;
}

interface Props {
  category: string;
  gender: string;
  currentProductId: number;
}

export default function SimilarProducts({ category, gender, currentProductId }: Props) {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSimilarProducts();
  }, [category, gender, currentProductId]);

  const fetchSimilarProducts = async () => {
    try {
      const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('category', category)
        .eq('gender', gender)
        .neq('id', currentProductId)
        .order('views', { ascending: false })
        .limit(8);

      if (error) throw error;
      setProducts(data || []);
    } catch (error) {
      console.error('Benzer ürünler yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mb-16">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Benzer Ürünler</h2>
      
      {loading ? (
        <div className="flex items-center justify-center py-20">
          <div className="w-16 h-16 border-4 border-rose-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      ) : products.length === 0 ? (
        <div className="text-center py-12 bg-gray-50 rounded-2xl">
          <i className="ri-shopping-bag-line text-5xl text-gray-300 mb-4"></i>
          <p className="text-gray-600">Benzer ürün bulunamadı</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop>
          {products.map((product) => (
            <ProductCard key={product.id} product={product} showVariations={false} />
          ))}
        </div>
      )}
    </div>
  );
}
